export default __webpack_public_path__ + "static/media/communications-sidebar-icon.ec2309ca.svg";